export enum CandidateSource {
  RecruiterUpload = 'recruiter_upload',
  CandidateApplication = 'candidate_application'
}
